import styled from "styled-components"
import { AutoComplete } from "primereact/autocomplete"

const StyledAutoComplete = styled(AutoComplete)``

export default StyledAutoComplete
